/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { BATTLE_ROOMS_TAB_STATES } from 'constants'

export const LEVEL_FILTER_TOOLTIP_TITLE = level => (
    <FormattedMessage
        id='battle_rooms.level_filter_tooltip_title'
        defaultMessage='Вылазки в {level} дивизионе'
        values={{ level }}
    />
)

export const LEVEL_FILTER_TOOLTIP_DESCRIPTION = {
    vehicleLevels: (
        <FormattedMessage
            id='battle_rooms.level_filter_tooltip_description.vehicalLevels'
            defaultMessage='уровень техники'
        />
    ),
    playersNumber: (
        <FormattedMessage
            id='battle_rooms.level_filter_tooltip_description.playersCount'
            defaultMessage='количество игроков в отряде, включая легионеров'
        />
    ),
    legionariesNumber: (
        <FormattedMessage
            id='battle_rooms.level_filter_tooltip_description.maxLegioners'
            defaultMessage='максимальное количество легионеров в отряде'
        />
    ),
    battleDuration: (
        <FormattedMessage
            id='battle_rooms.level_filter_tooltip_description.maxBattleDuration'
            defaultMessage='максимальная длительность боя'
        />
    ),
}

export const LEVEL_FILTER_TOOLTIP_FILTER_ACTIONS = {
    [BATTLE_ROOMS_TAB_STATES.UNITS]: (
        <FormattedMessage
            id='battle_rooms.units.level_filter_tooltip_filter_action'
            defaultMessage='Нажмите, чтобы отобразить отряды для сражений в этом режиме.'
        />
    ),
    [BATTLE_ROOMS_TAB_STATES.MATCHING]: (
        <FormattedMessage
            id='battle_rooms.matching.level_filter_tooltip_filter_action'
            defaultMessage='Нажмите, чтобы выбрать этот режим.'
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/LevelFilterTooltip/constants.jsx